import { render } from "./powertrainS13.vue?vue&type=template&id=2d89511e&scoped=true"
import script from "./powertrainS13.vue?vue&type=script&lang=js"
export * from "./powertrainS13.vue?vue&type=script&lang=js"

import "./powertrainS13.vue?vue&type=style&index=0&id=2d89511e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d89511e"]])

export default __exports__